export class TerminaisModel {
  id: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/terminais/terminais.model.ts